import { createRouter, createWebHistory } from 'vue-router';

import Home from './pages/Home.vue';
// import About from './pages/About.vue';
// import Services from './pages/Services.vue';
import Contact from './pages/Contact.vue';
// import Appointments from './pages/Appointments.vue';
import Impressium from './pages/Impressium.vue';
import PrivacyPolicy from './pages/PrivacyPolicy.vue';
import NotFound from './pages/NotFound.vue';
import { ROUTES } from './constants';

const routes = [
  { path: ROUTES.HOME, component: Home },
  // { path: ROUTES.ABOUT, component: About },
  // { path: ROUTES.SERVICES, component: Services },
  { path: ROUTES.CONTACT, component: Contact },
  // { path: ROUTES.APPOINTMENTS, component: Appointments },
  { path: ROUTES.IMPRESSUM, component: Impressium },
  { path: ROUTES.PRIVACY_POLICY, component: PrivacyPolicy },
  { path: ROUTES.MATCH_ALL, component: NotFound }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0, behavior: "smooth" };
  },
});

export default router;